var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paginate',{attrs:{"page-count":_vm.pageCount,"click-handler":_vm.clickCallback,"container-class":'pagination',"page-class":'page-item',"prev-text":"","next-text":"","prev-class":"previous-page","next-class":"next-page"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }